import request from '@/shared/api/request';

export const deleteBucketCors = ({
  name,
  origin,
}: {
  name: string;
  origin: string;
}): Promise<unknown> =>
  request({
    url: `/buckets/${name}/cors/${origin}/`,
    method: 'DELETE',
  });
